import React from "react";
import { useFund } from "../../hooks/useFund";
import { RanksAndRisksContainer } from "./RanksAndRisksContainer";

export interface Props {
  isin: string;
}

export const RanksAndRisks = ({ isin }: Props) => {
  const { data, isFetching, isPending } = useFund(isin, {
    includeFundamentals: true,
  });
  return (
    <RanksAndRisksContainer
      isFetching={isFetching || isPending}
      fwwFundStars={data?.ratingFwwFundstars}
      srri={data?.riskLevelSrri}
    />
  );
};
